export default __webpack_public_path__ + "media/images/brighteon-social/Icon-LiveStream-Gray-6e64c488a84d5780bac0f7a672fd33c8.svg";